module.exports = __webpack_public_path__ + "static/media/default.9af60844.png";


//////////////////
// WEBPACK FOOTER
// ./src/hicCharge/index/default.png
// module id = 1198
// module chunks = 0